var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mp3Img",attrs:{"src":require("../../../assets/音频播放器.png"),"alt":""},on:{"click":_vm.bofang1}}),_c('audio',{ref:"audio",staticClass:"aud",attrs:{"src":_vm.audioUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }